import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyImport, LazyModule } from 'owa-bundling';
import { Loading, NetworkError } from 'owa-interstitial';

export { DEV_PANEL, WORK_PLAN, PEOPLE } from './HomeRoutes';

export { default as useHybridspaceHomeLinks } from './useHybridspaceHomeLinks';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HybridspaceHomeRoute" */ './lazyIndex'),
    { name: 'HybridspaceHomeRoute' }
);
export const PlacesHomeRouteLayout: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.PlacesHomeRouteLayout,
    Loading,
    NetworkError
);

export const lazyWorkplanModule: LazyImport<
    typeof lazyIndex,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m);

export const WorkplanScreen: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.WorkplanScreen,
    Loading,
    NetworkError
);
